import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=a43c74d8&"
import script from "./Label.vue?vue&type=script&lang=ts&"
export * from "./Label.vue?vue&type=script&lang=ts&"
import style0 from "./Label.vue?vue&type=style&index=0&id=a43c74d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports